const switchThemeConfig = {
    tokens: {
        trackMinWidth: 40,
        handleShadow: '0px 0px 1px 0px rgba(0, 0, 0, 0.30), 0px 4px 14px -1px rgba(0, 0, 0, 0.10)'
    }
};
export { switchThemeConfig };
